import { useLingui as _useLingui } from "../lib/i18n/useLingui";
import { Globe01 } from "../icons";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React, { useCallback, useState } from "react";
const faviconVariants = cva("", {
  variants: {
    size: {
      sm: "w-3 h-3",
      md: "w-5 h-5",
      lg: "w-6 h-6"
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
/**
 * Displays a website's favicon, from faviconUrl when provided or derived from
 * websiteUrl's domain otherwise, falling back to a globe icon while loading
 * or on failure. Use it to represent external websites or links compactly.
 * @summary Website favicon with globe fallback.
 */
export function FaviconIcon({
  faviconUrl,
  websiteUrl,
  size = "sm",
  className
}) {
  const {
    _: _t
  } = _useLingui();
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const handleError = useCallback(() => {
    setHasError(true);
    setIsLoading(false);
  }, []);
  const handleLoad = useCallback(() => {
    setIsLoading(false);
  }, []);

  // Determine favicon URL
  let finalFaviconUrl = faviconUrl;
  if (!finalFaviconUrl && websiteUrl) {
    try {
      const domain = new URL(websiteUrl).hostname;
      finalFaviconUrl = `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;
    } catch (_unused) {
      // Invalid URL, fallback to icon
    }
  }

  // If no favicon URL or it failed to load, show fallback icon
  if (!finalFaviconUrl || hasError) {
    return /*#__PURE__*/React.createElement(Globe01, {
      className: className
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn("relative flex items-center justify-center", faviconVariants({
      size
    }), className)
  }, /*#__PURE__*/React.createElement("img", {
    src: finalFaviconUrl,
    alt: _t(
    /** i18n */
    {
      id: "1LUSIz",
      message: "Website icon"
    }),
    className: cn("object-contain", faviconVariants({
      size
    })),
    onError: handleError,
    onLoad: handleLoad,
    style: {
      opacity: isLoading ? 0 : 1,
      transition: "opacity 0.2s ease-in-out"
    }
  }), (isLoading || hasError) && /*#__PURE__*/React.createElement(Globe01, {
    className: cn(faviconVariants({
      size
    }), isLoading ? "absolute inset-0" : "hidden")
  }));
}
//# sourceMappingURL=FaviconIcon.js.map